import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { StyledDragIcon } from "../ColumnOptionView/styles";

/**
 * Covers the viewport so the dragged card can be placed in client coordinates, which is what
 * react-dnd's monitor reports. `pointer-events: none` keeps the drop targets underneath reachable —
 * without it the layer would sit between the cursor and the list and no hover would ever fire.
 */
export const StyledDragLayer = styled.div`
    position: fixed;
    inset: 0;
    z-index: 10000;
    pointer-events: none;
`;

export const StyledDragLayerItem = styled.div`
    position: absolute;
    top: 0;
    left: 0;

    /* The ghost can never match the row's :hover rule, so restate the handle's hovered fill here. */
    ${StyledDragIcon} {
        fill: ${colorsPalettes.bluegrey[600]};
    }
`;
